module.exports = __webpack_public_path__ + "fonts/SimplerPro_V3-Bold.07ff681f.otf";